import { FoodDataService } from './food-data.service';
import { Injectable } from '@angular/core';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { baseUrl } from 'src/app/global-variables';
import {
  DietListResponse,
  FoodListResponse,
  CheatDayResponse,
  FindMealResponse,
  ChangeStatusResponse,
  ChangeStartDayResponse,
  GetSelectedPackageResponse,
  FindFoodResponse,
  AddOrEditFoodResponse,
  RemoveFoodResponse,
  ChangeFastingStartTimeResponse,
} from 'src/app/core/model/api-response/diet-response-model';
import { UserDataService } from '../user-repository/user-data.service';
import { DietDataService } from './diet-data.service';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';
import { DietModel } from 'src/app/core/model/object/diet-model';
import {
  FoodFactModel,
  FoodFacts,
  FoodFactsModel,
} from 'src/app/core/model/object/diet-food-model';

@Injectable({
  providedIn: 'root',
})
export class DietApiService {
  foodIds = [];

  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private dietDataService: DietDataService,
    private userRefreshTokenService: UserRefreshTokenService,
    private foodDataService: FoodDataService
  ) {}

  getDiets(): Promise<GenericResponse> {
    let response: GenericResponse;
    let updatedAt: string;
    let savedDiet = false;
    let diets: DietModel[];
    return this.dietDataService.getDiets().then((res) => {
      let needRefresh = false;
      if (res.updatedAt) {
        diets = res.diets;
        for (let i = 0; i < diets.length; i++) {
          if (!diets[i].type || (diets[i].type && !diets[i].type.name)) {
            this.getDietsAndRefreshDB();
            return;
          }
        }
        if (!localStorage.getItem('newDietModel')) {
          needRefresh = true;
        } else if (
          new Date().getTime() - new Date(res.updatedAt).getTime() <
          30 * 60 * 1000
        ) {
          response = new GenericResponse(
            true,
            new GenericResponseData({ type: 'dontGetFoods' })
          );
          return response;
        }
        const ids = [];
        const startDays = [];
        for (let i = 0; i < diets.length; i++) {
          if (!ids.includes(diets[i]._id)) {
            startDays.push(diets[i].startDate);
            ids.push(diets[i]._id);
          } else {
            needRefresh = true;
          }
        }
        if (!needRefresh) {
          for (let i = 0; i < startDays.length; i++) {
            for (let j = i + 1; j < startDays.length; j++) {
              // console.log('dif', Math.abs(startDays[i] - startDays[j]))
              if (
                Math.abs(startDays[i] - startDays[j]) <
                10 * 24 * 60 * 60 * 1000
              ) {
                needRefresh = true;
              }
            }
          }
        }
        // console.log('needRefresh ', needRefresh, ids, startDays)
        if (needRefresh) {
          updatedAt = '2010-04-06T17:11:29.981Z';
        } else {
          updatedAt = res.updatedAt;
          savedDiet = true;
        }
      } else {
        updatedAt = '2010-04-06T17:11:29.981Z';
      }
      const headerDict = this.userDataService.getHeaderDict();
      return this.http
        .get<DietListResponse>(
          baseUrl + 'api/v2/diet/list?updatedAt=' + updatedAt,
          {
            headers: new HttpHeaders(headerDict),
          }
        )
        .toPromise()
        .then(async (result) => {
          // console.log(result);
          if (result.success) {
            if (!savedDiet || result.diets.length !== 0) {
              if (savedDiet) {
                result.diets.forEach((d) => {
                  let found = false;
                  for (let i = 0; i < diets.length; i++) {
                    if (diets[i]._id === d._id) {
                      found = true;
                      diets[i] = d;
                    }
                  }
                  if (!found) {
                    diets.push(d);
                  }
                });
                await this.dietDataService.saveDiets(diets);
              } else {
                await this.dietDataService.saveDiets(result.diets);
              }
              if (result.diets.length !== 0) {
                await this.prepareFoodIds(result.diets);
                response = new GenericResponse(
                  true,
                  new GenericResponseData({ type: 'getFoods' })
                );
              } else {
                response = new GenericResponse(
                  true,
                  new GenericResponseData({ type: 'dontGetFoods' })
                );
              }
            } else {
              response = new GenericResponse(
                true,
                new GenericResponseData({ type: 'dontGetFoods' })
              );
            }
          } else {
            response = new GenericResponse(false);
          }
          return response;
        })
        .catch((e) => {
          console.log(e.status, e);
          if (e.status === 403 || e.status === 401) {
            this.userRefreshTokenService.refreshToken().then((resp) => {
              if (resp.isSuccess()) {
                this.getDiets();
              }
            });
          }
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: 'خطای اتصال' })
          );
          return response;
        });
    });
  }

  getDietsAndRefreshDB(): Promise<GenericResponse> {
    let response: GenericResponse;
    const updatedAt = '2010-04-06T17:11:29.981Z';
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<DietListResponse>(
        baseUrl + 'api/v2/diet/list?updatedAt=' + updatedAt,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (result) => {
        // console.log(result);
        // alert(JSON.stringify(result.diets));
        if (result.success) {
          if (result.diets.length !== 0) {
            await this.dietDataService.deleteAndSaveDiets(result.diets);
            if (result.diets.length !== 0) {
              this.prepareFoodIds(result.diets);
              response = new GenericResponse(
                true,
                new GenericResponseData({ type: 'getFoods' })
              );
            } else {
              response = new GenericResponse(
                true,
                new GenericResponseData({ type: 'dontGetFoods' })
              );
            }
          } else {
            response = new GenericResponse(
              true,
              new GenericResponseData({ type: 'dontGetFoods' })
            );
          }
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getDietsAndRefreshDB();
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getDietsFoods(): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<FoodListResponse>(
        baseUrl + 'api/v2/diet/foods',
        {
          foodIds: this.foodIds,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (result) => {
        // console.log(result);
        if (result.success) {
          if (result.foods.length !== 0) {
            result.foods.forEach((food, i) => {
              result.foods[i].foodFactModel = this.makeFoodFactsModel(
                food.foodFact
              );
            });
            await this.foodDataService.saveFoods(result.foods);
          }
        }
        response = new GenericResponse(result.success);
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getDietsFoods();
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getFoods(foodIds: string[], saveFoods: boolean): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    foodIds = foodIds.filter((v) => {
      if (v) {
        return v;
      }
    });
    if (foodIds.length <= 0) {
      return Promise.reject(new GenericResponse(false));
    }
    return this.http
      .post<FoodListResponse>(
        baseUrl + 'api/v2/diet/foods',
        {
          foodIds,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (result) => {
        // console.log(result);
        if (result.success) {
          if (result.foods.length !== 0) {
            if (saveFoods) {
              result.foods.forEach((food, i) => {
                result.foods[i].foodFactModel = this.makeFoodFactsModel(
                  food.foodFact
                );
              });
              await this.foodDataService.saveFoods(result.foods);
              response = new GenericResponse(true);
            } else {
              response = new GenericResponse(
                true,
                new GenericResponseData({ foods: result.foods })
              );
            }
          } else {
            response = new GenericResponse(true);
          }
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getFoods(foodIds, saveFoods);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  dietCheat(dietId: string, day: number, isCheat: boolean) {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<CheatDayResponse>(
        baseUrl + 'api/v2/diet/' + dietId + '/cheat',
        {
          day,
          isCheat,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        // console.log(result);
        response = new GenericResponse(result.success);
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.dietCheat(dietId, day, isCheat);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  changeStatus(dietId: string, day: string, meal: string, status: string) {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<ChangeStatusResponse>(
        baseUrl + 'api/v2/diet/' + dietId + '/mealStatus',
        {
          day,
          meal,
          status,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        // console.log(result);
        response = new GenericResponse(result.success);
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.changeStatus(dietId, day, meal, status);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  findPackage(dietId: string, meal: string, foodName: string) {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<FindMealResponse>(
        baseUrl +
          'api/v2/diet/' +
          dietId +
          '/packagesV2?meal=' +
          meal +
          '&foodName=' +
          foodName,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        // console.log(result);
        if (result.success) {
          response = new GenericResponse(
            true,
            new GenericResponseData({ meals: result.packages })
          );
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.findPackage(dietId, meal, foodName);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  findFood(foodName: string) {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<FindFoodResponse>(
        baseUrl + 'api/v2/diet/searchFoods?query=' + foodName,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ searchedFoods: result.foods })
        );
      })
      .catch((e) => {
        // if (e.status === 403 || e.status === 401) {
        //   this.userRefreshTokenService.refreshToken().then((resp) => {
        //     if (resp.isSuccess()) {
        //       this.findFood(foodName);
        //     }
        //   });
        // }

        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }

  addFood(
    dietId: string,
    day: string,
    meal: string,
    foodId: string,
    unit: string,
    amount: number
  ) {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<AddOrEditFoodResponse>(
        baseUrl + 'api/v2/diet/' + dietId + '/food',
        {
          day,
          meal,
          foodId,
          unit,
          amount,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        // console.log(result);
        response = new GenericResponse(
          result.success,
          new GenericResponseData({
            message: result.message,
            addOrEditFoodResponse: result.food,
          })
        );
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.addFood(dietId, day, meal, foodId, unit, amount);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  editFood(
    dietId: string,
    day: string,
    meal: string,
    foodId: string,
    unit: string,
    amount: number,
    mealFoodId: string
  ) {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .patch<AddOrEditFoodResponse>(
        baseUrl + 'api/v2/diet/' + dietId + '/food',
        {
          day,
          meal,
          foodId,
          unit,
          amount,
          mealFoodId,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        // console.log(result);
        response = new GenericResponse(
          result.success,
          new GenericResponseData({
            message: result.message,
            addOrEditFoodResponse: result.food,
          })
        );
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.editFood(
                dietId,
                day,
                meal,
                foodId,
                unit,
                amount,
                mealFoodId
              );
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  removeFood(dietId: string, day: string, meal: string, mealFoodId: string) {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    const options = {
      headers: new HttpHeaders(headerDict),
      body: {
        day,
        meal,
        mealFoodId,
      },
    };
    return this.http
      .delete<RemoveFoodResponse>(
        baseUrl + 'api/v2/diet/' + dietId + '/food',
        options
      )
      .toPromise()
      .then((result) => {
        // console.log(result);
        response = new GenericResponse(
          result.success,
          new GenericResponseData({ message: result.message })
        );
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.removeFood(dietId, day, meal, mealFoodId);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getSelectedPackage(dietId: string, pgId: string) {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<GetSelectedPackageResponse>(
        baseUrl + 'api/v2/diet/' + dietId + '/package/' + pgId,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        if (result.success) {
          response = new GenericResponse(
            true,
            new GenericResponseData({ meals: result['package'] })
          );
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getSelectedPackage(dietId, pgId);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  changePackage(
    dietId: string,
    packageId: string,
    day: string,
    meal: string
  ): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .put<ChangeStatusResponse>(
        baseUrl + 'api/v2/diet/' + dietId + '/meal',
        {
          day,
          meal,
          packageId,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        // console.log(result);
        response = new GenericResponse(result.success);
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.changePackage(dietId, packageId, day, meal);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  changeStartDay(dietId: string, startDay: number): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .patch<ChangeStartDayResponse>(
        baseUrl + 'api/v2/diet/' + dietId + '/startDay',
        {
          startDay,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        if (result.success) {
          response = new GenericResponse(
            result.success,
            new GenericResponseData({ startDay: result.startDate })
          );
        } else {
          response = new GenericResponse(result.success);
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.changeStartDay(dietId, startDay);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({
            message: e.error && e.error.message ? e.error.message : '',
          })
        );
        return response;
      });
  }

  changeFastingStartTime(
    fastingTime: number,
    dietId: string
  ): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .patch<ChangeFastingStartTimeResponse>(
        baseUrl + 'api/v2/diet/' + dietId + '/fastingTime',
        {
          fastingTime,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        response = new GenericResponse(result.success);
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.changeFastingStartTime(fastingTime, dietId);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({
            message: e.error && e.error.message ? e.error.message : '',
          })
        );
        return response;
      });
  }

  async prepareFoodIds(diets: DietModel[]) {
    this.foodIds = [];
    diets.forEach((diet) => {
      diet.days.forEach((day) => {
        day.meals.forEach((meal) => {
          meal.foods.forEach((food) => {
            this.foodIds.push(food.food);
          });
        });
      });
    });

    const uniqueSet = new Set(this.foodIds);
    this.foodIds = [...uniqueSet];
    this.foodIds = await this.foodDataService.checkFoodIds(this.foodIds);
  }

  makeFoodFactsModel(f: FoodFacts): FoodFactsModel {
    const calorie = new FoodFactModel('calorie', f.calorieAmount);
    const protein = new FoodFactModel('protein', f.proteinAmount);
    const fat = new FoodFactModel('fat', f.fatAmount);
    const carbohydrat = new FoodFactModel('carbohydrate', f.carbohydrateAmount);
    const sugar = new FoodFactModel('sugar', f.sugarAmount);
    const fiber = new FoodFactModel('fiber', f.fiberAmount);
    const sodium = new FoodFactModel('sodium', f.sodiumAmount);
    const potassium = new FoodFactModel('potassium', f.potassiumAmount);
    const calcium = new FoodFactModel('calcium', f.calciumAmount);
    const magnesium = new FoodFactModel('magnesium', f.magnesiumAmount);
    const iron = new FoodFactModel('iron', f.ironAmount);
    const cholesterol = new FoodFactModel('cholesterol', f.cholesterolAmount);
    const phosphor = new FoodFactModel('phosphor', f.phosphorAmount);
    const saturatedFat = new FoodFactModel(
      'saturatedFat',
      f.saturatedFatAmount
    );
    const polyunsaturatedFat = new FoodFactModel(
      'polyunsaturatedFat',
      f.polyunsaturatedFatAmount
    );
    const transFat = new FoodFactModel('transFat', f.transFatAmount);
    const monounsaturatedFat = new FoodFactModel(
      'monounsaturatedFat',
      f.monounsaturatedFatAmount
    );
    return new FoodFactsModel(
      calorie,
      protein,
      fat,
      carbohydrat,
      sugar,
      fiber,
      sodium,
      potassium,
      calcium,
      magnesium,
      iron,
      cholesterol,
      phosphor,
      saturatedFat,
      polyunsaturatedFat,
      transFat,
      monounsaturatedFat
    );
  }
}
